// @TECHDEBT: this function can be replaced by isDateString()
const isDate = (date) => /^\d{4}-\d{2}-\d{2}$/.test(date);
export class AvailabilityCalendar {
    constructor(data) {
        Object.defineProperty(this, "checkin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = {};
        if (data) {
            for (const key in data) {
                if (!isDate(key)) {
                    continue;
                }
                this.data[key] = data[key];
            }
        }
    }
}
export default AvailabilityCalendar;
